import { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchCarts } from "../../store/action/cartAction";
import '../../assets/styles/main.scss';
import Order from "./order";
import Infor from "./infor";

const Cart = (props) => {
   const { fetchCarts, carts } = props;
   const params = useParams();
   const { id } = params;
   useEffect(() => {
      fetchCarts(id)
   }, [id]);

   return (
      <div className="cart-container">
         <div className="cart-wrapper">
            {carts.draft_status == 1 ?
               <Infor />
               :
               <Order />
            }
         </div>
      </div>
   );
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
   fetchCarts
})(Cart);
